export default __webpack_public_path__ + "static/media/biofit-builder-series-TX.002f42a2.png";